Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('color-picker', require('./components/ColorPicker.vue').default);

Vue.component('home', require('./components/pages/home/home.vue').default);
Vue.component('marshal-notes-modal', require('./components/pages/home/marshal-notes-modal.vue').default);

/** Member Page Components */
Vue.component('member-create', require('./components/pages/member/member_create.vue').default);
Vue.component('member-list', require('./components/pages/member/member_list.vue').default);
Vue.component('member-card', require('./components/pages/member/member_card.vue').default);
Vue.component('member-view', require('./components/pages/member/member_view.vue').default);
Vue.component('member-birthday', require('./components/pages/member/member_birthday.vue').default);

/** Member Level Components */
Vue.component('member-level-list', require('./components/pages/member-levels/member-level-list.vue').default);
Vue.component('member-level-create', require('./components/pages/member-levels/member-level-create.vue').default);

/** Game Page Components */

Vue.component('game-create', require('./components/pages/games/game_create.vue').default);
Vue.component('game-edit', require('./components/pages/games/game_edit.vue').default);
Vue.component('game-mass-create', require('./components/pages/games/game_mass_create.vue').default);
Vue.component('game-view', require('./components/pages/games/game_view.vue').default);
Vue.component('game-calendar', require('./components/pages/games/game_calendar.vue').default);
Vue.component('game-player-modal', require('./components/pages/games/player/PlayerModal.vue').default);
Vue.component('game-player-payment-modal', require('./components/pages/games/player/payments.vue').default);
Vue.component('game-open', require('./components/pages/games/game_open.vue').default);

/** Rental Types Components */
Vue.component('rental-type-create', require('./components/pages/rental-types/rental_type_create.vue').default);
Vue.component('rental-type-list', require('./components/pages/rental-types/rental_type_list.vue').default);

/** Site Components */
Vue.component('site-create', require('./components/pages/sites/site_create.vue').default);
Vue.component('site-list', require('./components/pages/sites/site_list.vue').default);

Vue.component('settings-index', require('./components/pages/settings/index.vue').default);

/** Teams Components */
Vue.component('teams-create', require('./components/pages/teams/teams-create.vue').default);
Vue.component('teams-list', require('./components/pages/teams/teams-list.vue').default);

/** User Components */
// Vue.component('user-create', require('./components/pages/users/user_create.vue').default);
Vue.component('user-list', require('./components/pages/users/user-list.vue').default);

/** Marshal Bookings Components */
Vue.component('marshal-booking', require('./components/pages/marshal-bookings/marshal-booking.vue').default);
Vue.component('marshal-booking-list', require('./components/pages/marshal-bookings/marshal-booking-list.vue').default);
Vue.component('marshal-booking-view', require('./components/pages/marshal-bookings/marshal-booking-view.vue').default);

/** Public Components */
Vue.component('public-index', require('./components/pages/public/index.vue').default);
Vue.component('public-member-register', require('./components/pages/public/member/member-register.vue').default);
Vue.component('public-login', require('./components/pages/public/auth/login.vue').default);
Vue.component('public-forgot', require('./components/pages/public/auth/forgot.vue').default);
Vue.component('public-booking-calendar', require('./components/pages/public/booking/calendar.vue').default);
Vue.component('public-booking-modal', require('./components/pages/public/booking/booking-modal.vue').default);
Vue.component('public-booking-cancel-modal', require('./components/pages/public/booking/cancel-modal.vue').default);
Vue.component('public-blocked', require('./components/pages/public/auth/blocked.vue').default);
Vue.component('public-agreement', require('./components/pages/public/agreement/index.vue').default);